var file_upload_viewer_default = {
  "fontElementMap": "Sk7Mg",
  "file_upload_container": "_6jlba",
  "file_upload_link": "_1vjrG",
  "file_upload_error_container": "_--Las",
  "file_upload_file_info": "EE1YY",
  "file_upload_type_icon": "Dw1fq",
  "file_upload_status_icon_container": "BsZUG",
  "file_upload_status_icon": "_5asuj",
  "file_upload_description": "UuAJG",
  "file_upload_name_container": "NywVp",
  "file_upload_name": "Knz1m",
  "file_upload_extension": "QBj5p",
  "file_loader_icon": "pVjLl",
  "file_upload_icon_frame": "OHTOp",
  "file_upload_icon_background": "PPYd7"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
